import { CULTURES, QUESTION_CODES, CODE_TO_TARGETS } from '../surveys/myculture-pref.js'

// Tent-Funktion: Punkte für eine Option an Position `targetIdx` in einem N-Way-Vergleich,
// gegeben Slider-Wert v (1..5).
// Targets: 2-Way → [1, 5], 3-Way → [1, 3, 5]
// Punkte = max(0, 1 - dist/maxDist) wobei maxDist je nach N
function pointsForOption(value, targetIdx, total) {
  const targets = total === 2 ? [1, 5] : [1, 3, 5]
  const target = targets[targetIdx]
  const dist = Math.abs(value - target)
  // 2-Way: linear über 4 Schritte; 3-Way: nur Nachbarn (2 Schritte)
  const maxDist = total === 2 ? 4 : 2
  return Math.max(0, 1 - dist / maxDist)
}

// Berechne Profil aus den Antworten.
// Input: data.answers = { p3: 1..5, ... }
// Output: sortierte Liste aller Kulturtypen mit Punkten + Prozent + primary/secondary
export function computeMyCulture(data) {
  const answers = data?.answers || {}
  const points = {}
  const max = {}
  for (const id of Object.keys(CULTURES)) {
    points[id] = 0
    max[id] = 0
  }

  for (const [key, code] of Object.entries(QUESTION_CODES)) {
    const targets = CODE_TO_TARGETS[code]
    if (!targets) continue
    const v = answers[key]
    targets.forEach((cultureId, idx) => {
      // Maximum: jeder Frage trägt 1 Punkt zum jeweiligen Kulturtyp bei
      max[cultureId] += 1
      if (typeof v === 'number' && v >= 1 && v <= 5) {
        points[cultureId] += pointsForOption(v, idx, targets.length)
      }
    })
  }

  const list = Object.values(CULTURES).map(c => ({
    ...c,
    points: points[c.id],
    max: max[c.id],
    pct: max[c.id] > 0 ? Math.round((points[c.id] / max[c.id]) * 100) : 0,
  }))
  list.sort((a, b) => b.pct - a.pct)
  return {
    cultures: list,
    primary: list[0],
    secondary: list[1] && list[1].pct > 0 ? list[1] : null,
    topPct: list[0]?.pct || 0,
  }
}

// Hilfs-Lookup: Kulturtyp-ID → object aus computed list (für Grid-Render)
export function indexById(profile) {
  const map = {}
  for (const c of profile.cultures) map[c.id] = c
  return map
}
